import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AddStaffForm,
  StaffFilterParams,
  StaffListResponse,
} from "../../types/staff";
import StaffApis from "../../api/staffApis";
import { RootState } from "../../store";

interface StaffState {
  staffList: AddStaffForm[];
  loading: boolean;
  error: string | null;
  filters: StaffFilterParams;
  total: number;
}

const initialState: StaffState = {
  staffList: [],
  loading: false,
  error: null,
  filters: {
    branchCode: "",
    page: 0,
    size: 10,
    fullName: "",
    mobile: "",
    className: "",
    subjectName: ""
  },
  total: 0
};

export const fetchStaff = createAsyncThunk<
  StaffListResponse,
  StaffFilterParams,
  { rejectValue: string; state: RootState }
>("staff/fetchStaff", async (params, { rejectWithValue }) => {
  try {
    const data = await StaffApis.getStaff(params);
    if (!data) throw new Error("No data returned");

    return {
      ...data,
    } as any;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch staff");
  }
});

const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<StaffFilterParams>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearStaffList: (state) => {
      state.staffList = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.staffList = action.payload.data.content ?? [];
        state.total = action.payload.data.totalElements ?? 0; 
      })

      .addCase(fetchStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch staff";
      });
  },
});

export const { clearStaffList, setFilters } = staffSlice.actions;
export const selectStaff = (state: RootState) => state.staff;
export default staffSlice.reducer;
